// Unread-count badge label for the notification bell: caps at 99+ so the
// pill stays one glyph wide. Standalone (no React/router imports) so it's
// unit-testable without rendering the router-coupled NotificationBell.
// Visibility is gated separately by `unread > 0` in the component.
export function badgeLabel(unread) {
  return unread > 99 ? '99+' : String(unread);
}
